function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSelectCategory = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16v16H0z",
  "data-name": "Rectangle 363",
  style: {
    fill: "transparent"
  }
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Ellipse 50",
  style: {
    fill: "#fff",
    stroke: "#eaeaea"
  }
}, /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  stroke: "none",
  style: {
    stroke: "none"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 7.5,
  style: {
    fill: "none"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "m225.062 24.144 2.807 2.92 2.807-2.92",
  "data-name": "Path 404",
  style: {
    stroke: "#000",
    strokeLinejoin: "round",
    fill: "none"
  },
  transform: "translate(-219.869 -17.604)"
}));
export default SvgIconSelectCategory;